var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';
export function createIntlProvider(translationsService, 
// eslint-disable-next-line @typescript-eslint/naming-convention -- See @typescript-eslint/naming-convention configuration for explanation
TextComponent) {
    function TranslationsProvider(_a) {
        var { children, onTranslationsFetchSuccess, onTranslationsFetchError } = _a, props = __rest(_a, ["children", "onTranslationsFetchSuccess", "onTranslationsFetchError"]) // we want to proxy all props to IntlProvider to allow user to override
        ;
        const [translationFile, setTranslationFile] = useState(translationsService.getCurrentTranslations());
        /* eslint-disable react-hooks/exhaustive-deps */
        const messages = useMemo(() => translationsService.getCurrentTranslations(), [translationFile, translationsService]);
        /* eslint-enable */
        useEffect(() => {
            const unsubscribe = translationsService.onSync((translations) => setTranslationFile(translations));
            const syncTranslations = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield translationsService.syncTranslations();
                    if (onTranslationsFetchSuccess) {
                        onTranslationsFetchSuccess(translationsService.getCurrentTranslations());
                    }
                }
                catch (e) {
                    if (onTranslationsFetchError) {
                        onTranslationsFetchError(e);
                    }
                }
            });
            syncTranslations();
            return () => unsubscribe();
        }, [onTranslationsFetchSuccess, onTranslationsFetchError]);
        return (React.createElement(IntlProvider, Object.assign({ locale: translationsService.getLocale(), messages: messages, textComponent: TextComponent }, props), children));
    }
    return TranslationsProvider;
}
